import { render, staticRenderFns } from "./RegisterNowTeaser.vue?vue&type=template&id=0af07be4&scoped=true&"
import script from "./RegisterNowTeaser.vue?vue&type=script&lang=js&"
export * from "./RegisterNowTeaser.vue?vue&type=script&lang=js&"
import style0 from "./RegisterNowTeaser.vue?vue&type=style&index=0&id=0af07be4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af07be4",
  null
  
)

export default component.exports